import { CouplePlanningDto, UpdateCouplePlanningDto } from 'src/dto/couple-planning.dto'
import { API } from '../config'
import { AxiosResponse } from 'axios'

const BASE_URL = 'entity/CasalPlanejado'

export class CouplePlanningService {
  public async getCouplePlanningList(farmId: string): Promise<AxiosResponse<CouplePlanningDto[]>> {
    return await API.get(`${BASE_URL}/${farmId}`)
  }

  public async updateCouplePlanning(
    farmId: string,
    couplePlanningDto: UpdateCouplePlanningDto
  ): Promise<AxiosResponse<CouplePlanningDto>> {
    return await API.put(`${BASE_URL}/${farmId}`, couplePlanningDto)
  }
}
